import authService from './authService';
import usersService from './usersService';
import accountService from './accountService';
import testimonialsService from './testimonialsService';
import formsService from './formsService';
import widgetsService from './widgetsService';
import reviewBoosterService from './reviewBoosterService';
import muxService from './muxService';
import surveysService from './surveysService';

module.exports = {
  authService,
  usersService,
  testimonialsService,
  formsService,
  widgetsService,
  reviewBoosterService,
  accountService,
  muxService,
  surveysService,
};
